import StartIssueTestLink from './StartIssueTestLink.vue'

const issueComponents = [StartIssueTestLink]

export default issueComponents
